import { useEffect, useState } from "react";
import { fetchTeamMembers, TeamMember } from "../api/contentful";

export function useTeamMembers() {
  const [data, setData] = useState<TeamMember[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchTeamMembers()
      .then((res) => setData(res))
      .catch((err) => setError(err.message || "Failed to load team members"))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
